const ENV_CONFIG = require(`./config.${process.env.REACT_APP_ENVIRONMENT}.json`)

declare global {
  interface Window {
    GR_API_URLS: {
      API_URL_CORE: string
      API_URL_TOP_GROSSING: string
      API_URL_FEED: string
      API_URL_ACCOUNT: string
      API_URL_CONNECT_SERVER: string
      API_URL_AI_ANALYST: string
      API_URL_REPORTS: string
      API_URL_AI_ANALYST_INTERNAL: string
      API_URL_LIVE_EVENTS_PREDICTIONS: string
      API_URL_UA_INSIGHTS: string
    }
    Keycloak: any
    MIXPANEL_CONFIG: {
      key: string
      enable: boolean
    }
    INTERCOM_CONFIG: {
      appId: string
      enable: boolean
    }
    _hsq: any // hubspotquery
    Intercom: any
  }
}

// `yarn start:sandbox` calls the sandbox frontend URL directly; its nginx routes /s/* to the sandbox services.
const getApiUrls = () => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'local-dev-sandbox') {
    return ENV_CONFIG.GR_API_URLS
  }

  const sandboxUrl = process.env.REACT_APP_SANDBOX_URL
  if (!sandboxUrl) {
    throw new Error(
      'REACT_APP_SANDBOX_URL is not set. Add the sandbox frontend URL from the "Sandbox frontend ready" PR comment to .env.local and restart, e.g. ' +
        'REACT_APP_SANDBOX_URL=https://client-sandbox-<name>.apps.<cluster>.openshiftapps.com'
    )
  }

  const origin = new URL(/^https?:\/\//.test(sandboxUrl) ? sandboxUrl : `https://${sandboxUrl}`).origin

  return Object.fromEntries(Object.entries<string>(ENV_CONFIG.GR_API_URLS).map(([key, path]) => [key, `${origin}${path}`]))
}

if (!window.GR_API_URLS) {
  window.GR_API_URLS = getApiUrls()
}

if (!window.MIXPANEL_CONFIG) {
  window.MIXPANEL_CONFIG = ENV_CONFIG.MIXPANEL_CONFIG
}

if (!window.INTERCOM_CONFIG) {
  window.INTERCOM_CONFIG = ENV_CONFIG.INTERCOM_CONFIG
}

export {}
